import React from "react";
import ReactDOM from "react-dom";
import styled from "styled-components";
import { isMobile } from "@kubera/common";

import CloseIcon from "assets/images/close.svg?react";

const isMobileDevice = isMobile();

const Banner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  left: 0;
  bottom: 0;
  background: #ffe600;
  width: 100%;
  min-height: 3.125rem;
  z-index: 10000;
`;

const BannerContent = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const CloseBtn = styled.div`
  position: absolute;
  right: ${isMobileDevice ? "-0.25rem" : "0.9375rem"};
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3.75rem;
  height: 100%;
  cursor: pointer;
`;

const CloseIconComponent = styled(CloseIcon)`
  width: ${isMobileDevice ? "0.8125rem" : null};
  height: ${isMobileDevice ? "0.8125rem" : null};
  color: #000;
`;

const BannerComponent = props => {
  const bannerContent = (
    <Banner className={props.className}>
      <BannerContent>
        {props.children}
        <CloseBtn onClick={props.onClose}>
          <CloseIconComponent />
        </CloseBtn>
      </BannerContent>
    </Banner>
  );

  return ReactDOM.createPortal(bannerContent, document.querySelector("body"));
};

export default BannerComponent;
